/**
 * Shared theme metadata. The colour tokens themselves live in `theme.css`
 * (imported via `@myosh/design-system/styles`); this module just names the themes so the
 * admin picker and the theme provider agree on the set.
 */

export type { ColorScheme } from './color-scheme';
export {
  applyColorScheme,
  applyStoredColorScheme,
  mountColorSchemeStylesheet,
  toColorScheme,
} from './color-scheme';

export const THEME_NAMES = ['blue', 'brown', 'green', 'grey', 'orange', 'purple', 'red', 'yellow'] as const;

export type ThemeName = (typeof THEME_NAMES)[number];

export const DEFAULT_THEME: ThemeName = 'blue';

/** Narrow an arbitrary string (e.g. the backend `company-theme`) to a known theme. */
export const toThemeName = (value: string | undefined | null): ThemeName => {
  return THEME_NAMES.includes(value as ThemeName) ? (value as ThemeName) : DEFAULT_THEME;
};
